import tippy from "tippy.js";



export default function () {
	return tippy('[data-tippy-content]',{
		trigger: 'mouseenter focus',
		interactive: true,
		placement: 'top',
		animation: 'shift-away-subtle',
		appendTo: () => document.body,
	});
}